module.exports = __webpack_public_path__ + "img/Event3.3d8f704e.jpg";